export enum DialogType {
  info,
  error,
  warning,
  success,
  notSet,
}
